module.exports = __webpack_public_path__ + "assets/img/00014.fa56f3df.png";